module.exports = __webpack_public_path__ + "static/media/HS438HJ.de7a5748.jpg";